import { render } from "./Curation.vue?vue&type=template&id=a8bc202a&scoped=true"
import script from "./Curation.vue?vue&type=script&lang=js"
export * from "./Curation.vue?vue&type=script&lang=js"

import "./Curation.vue?vue&type=style&index=0&id=a8bc202a&scoped=true&lang=css"

import exportComponent from "/Users/lougotz/Sites/hippocrates/glossary-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8bc202a"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QIcon,QCheckbox,QBtn,QSelect,QBadge,QTooltip,QPagination});
